"use client";

import Link from "next/link";
import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";
import {
  ContentWrapper,
  FeaturedImgBox,
  StyledCard,
} from "src/lib/components/category-item/vertical/styles";
import { H2 } from "src/lib/components/salify-next-layout/default/components/Typography";
import { toAssetImages } from "src/lib/utils";

// ============================================================
const CategoryItemVertical = (props: any) => {
  return (
    <StyledCard
      sx={props.sx}
      style={{
        width: "240px",
      }}
    >
      <FeaturedImgBox>
        <Link href={`/collection/${props.code}`}>
          <LazyImage
            alt={props.name}
            width={70}
            height={70}
            src={toAssetImages(props.imageUrlIcon)}
            style={{
              objectFit: "contain",
            }}
          />
        </Link>
      </FeaturedImgBox>

      <ContentWrapper>
        <Link href={`/collection/${props.code}`} className="title">
          <H2 mb={1} title={props.name} fontSize={18} fontWeight={600} color="text.secondary">
            {props.name}
          </H2>
        </Link>
      </ContentWrapper>
    </StyledCard>
  );
};

export default CategoryItemVertical;
